import styled from "styled-components";

import { mixins, colorsPalettes } from "@similarweb/styles";

export const EmptyStateMessageContainer = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const EmptyStateMessageTitle = styled.p`
    margin: auto 0 0;
    ${mixins.setFont({ $size: 16, $weight: 500, $color: colorsPalettes.carbon[500] })};
    line-height: 20px;
    text-align: center;
`;

export const EmptyStateMessageSubtitle = styled.p`
    margin: 0 0 auto;
    ${mixins.setFont({ $size: 12, $weight: 400, $color: colorsPalettes.carbon[300] })};
    line-height: 20px;
    text-align: center;
`;
